import { render } from "./PayersComponent.vue?vue&type=template&id=dff3a4c2&scoped=true"
import script from "./PayersComponent.vue?vue&type=script&lang=js"
export * from "./PayersComponent.vue?vue&type=script&lang=js"

import "./PayersComponent.vue?vue&type=style&index=0&id=dff3a4c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dff3a4c2"]])

export default __exports__